(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('lead-discount', {
            parent: 'entity',
            url: '/lead-discount?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.leadDiscount.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/lead-discount/lead-discounts.html',
                    controller: 'LeadDiscountController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('leadDiscount');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('lead-discount-detail', {
            parent: 'entity',
            url: '/lead-discount/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.leadDiscount.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/lead-discount/lead-discount-detail.html',
                    controller: 'LeadDiscountDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('leadDiscount');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'LeadDiscount', function($stateParams, LeadDiscount) {
                    return LeadDiscount.get({id : $stateParams.id});
                }]
            }
        })
        .state('lead-discount.new', {
            parent: 'lead-discount',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-discount/lead-discount-dialog.html',
                    controller: 'LeadDiscountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                hasRequestedDiscount: null,
                                requestedReasonOther: null,
                                isEntitledToDiscount: null,
                                entitledToReasonOther: null,
                                finalReasonOther: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('lead-discount', null, { reload: true });
                }, function() {
                    $state.go('lead-discount');
                });
            }]
        })
        .state('lead-discount.edit', {
            parent: 'lead-discount',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-discount/lead-discount-dialog.html',
                    controller: 'LeadDiscountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['LeadDiscount', function(LeadDiscount) {
                            return LeadDiscount.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('lead-discount', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('lead-discount.delete', {
            parent: 'lead-discount',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/lead-discount/lead-discount-delete-dialog.html',
                    controller: 'LeadDiscountDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['LeadDiscount', function(LeadDiscount) {
                            return LeadDiscount.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('lead-discount', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
